import { render, staticRenderFns } from "./PlayingDetails.vue?vue&type=template&id=0c13f6b8&scoped=true"
import script from "./PlayingDetails.vue?vue&type=script&lang=js"
export * from "./PlayingDetails.vue?vue&type=script&lang=js"
import style0 from "./PlayingDetails.vue?vue&type=style&index=0&id=0c13f6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13f6b8",
  null
  
)

export default component.exports